<div class="flex flex-row items-center h-20 px-8 gap-1 hover:bg-zen hover:bg-opacity-5 btn text-sm text-zen" [ngClass]="{'bg-zen bg-opacity-5 font-medium':active, 'pointer-events-none': !enabled}">
    <i *ngIf="icon" [class]="icon" class="fa-regular h-10 w-10 leading-10 text-center"></i>
    <ng-content></ng-content>
</div>
